var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ticket__description" },
    [
      _c(
        "p",
        { staticClass: "ticket__descriptionTitle" },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$tm(_vm.ticketConfiguration.product, "descriptionWebShop")
              ) +
              "\n    "
          ),
          _c("vvs", {
            key: _vm.ticketConfiguration.id,
            staticClass: "ticket__vvsIcon",
            attrs: { "ticket-configuration": _vm.ticketConfiguration },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.soldOut
        ? [
            _c("div", { staticClass: "ticket__sold-out" }, [
              _vm._v(
                "\n      - " +
                  _vm._s(_vm.$t("ticketList.ticketConfiguration.soldOut")) +
                  " -\n    "
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.productInfoText
        ? [
            _c("p", { staticClass: "ticket__infoTitle" }, [
              _vm._v(_vm._s(_vm.productInfoText)),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("p", { staticClass: "ticket__descriptionSubtitle" }, [
        _vm._v(
          _vm._s(_vm.$t("ticketList.ticketConfiguration.event")) +
            _vm._s(
              _vm.$tm(_vm.ticketConfiguration.event, "descriptionExternal")
            )
        ),
      ]),
      _vm._v(" "),
      !_vm.productPurchasable &&
      _vm.$tm(_vm.ticketConfiguration.product, "bookingUnavailableHint")
        ? [
            _c("p", { staticClass: "ticket__bookingUnavailable" }, [
              _vm._v(
                _vm._s(
                  _vm.$tm(
                    _vm.ticketConfiguration.product,
                    "bookingUnavailableHint"
                  )
                )
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }